import React, { Component } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import CatGrid from '../CatGrid';
import CatPanel from '../CatPanel';
import { useTranslation } from 'react-i18next';

function SkillPane(props) {
  const {t}=useTranslation();  
  const catAdded = (cat)=>{props.catAdded(cat)};
  const catChanged = (cat)=>{props.catChanged(cat)};
  const catDeleted = (cat)=>{props.catDeleted(cat)};
  const openPage = (cat)=>{props.selectionChanged(cat);
  }

  return(
  <React.Fragment>
  <CatPanel cat={props.cat} openPage={openPage}/>
  <TabView>
  <TabPanel  header={t("Outcome Mapping")}>
    <CatGrid parentCat={props.cat} mode="REL" catType="OUTCOME" catAdded={catAdded} catChanged={catChanged} catDeleted={catDeleted} openPage={openPage}/>
  </TabPanel>
  </TabView>
  </React.Fragment>
	)
}

export default SkillPane;
